<style>
.v-calendar-monthly .v-chip, .v-chip .v-chip__content {
  border-radius: 28px 5px 5px 28px;
}
</style>

<template>
<v-layout row wrap >
  <!-- S:<pre v-text='spaces' /> -->
  <v-flex v-if='sideMenu' xs12 sm4 md3 lg3 xl2 >
    <v-card tile dark height='100%' >
      <v-tabs grow dark v-model='activeTab' >
        <v-tab @click='monthView=true' >Month view</v-tab>
        <v-tab @click='monthView=false' >Side by side</v-tab>
      </v-tabs>

      <v-divider></v-divider>
      <v-date-picker full-width
        class='elevation-0'
        v-if='date'
        v-model='date'
        :type='pickerMode' />
      <v-switch v-if='monthView' v-model='hideWeekends' label='Hide weekends' class='mx-3 my-0' dense />

      <template name='calendars' >
        <v-subheader class='overline my-0' >Calendars</v-subheader>
        <v-list >
          <template v-for='(practitioner, practitionerId) in colleagues' >
            <practitioner-list-item
              :with-avatar='true'
              :item='practitioner' :key='practitionerId'
              @selected='setSelected(practitioner)' >
              <template slot='action' >
                <v-list-tile-action >
                  <v-btn @click.stop='newAppointment(practitioner)' icon small outline >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action >
                  <v-icon
                    v-if='practitioner.id in selectedPractitioners'
                    :color='practitioner.color' >check_box</v-icon>
                  <v-icon v-else
                    :color='practitioner.color' >check_box_outline_blank</v-icon>
                  <!-- <v-checkbox :value='practitioner.id in selectedPractitioners' :color='colors[index]' /> -->
                </v-list-tile-action>
              </template>
            </practitioner-list-item>
            <v-divider :key='`div-${practitioner.id}`' />
          </template>
        </v-list>
      </template>

      <template v-if='getSharedCalendars && getSharedCalendars.length > 0' >
        <v-subheader class='overline my-0' >Shared
          <v-spacer/>
          <v-btn small icon :loading='getLookupsRequest.loading' @click='getLookups' >
            <v-icon small >replay</v-icon>
          </v-btn >
        </v-subheader>
        <v-list>
          <v-list-tile v-for='cal in getSharedCalendars' :key='cal.id' >
            <v-list-tile-content>
              <!-- <v-list-tile-title > -->
                <v-checkbox v-model='visibleSharedCalendarIds' hide-details
                  :label='cal.title'
                  :value='cal.id' />
              <!-- </v-list-tile-title> -->
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </template>
      <v-card-actions >
        <invite-btn :attrs="{block: true}" />
      </v-card-actions>
      <!-- <pre>{{selectedPractitioners}}</pre> -->
    </v-card>
  </v-flex>
  <v-flex xs12 :sm8='sideMenu' :md9='sideMenu' :lg9='sideMenu' :xl10='sideMenu' >

    <v-toolbar dense flat dark >
      <v-toolbar-side-icon >
        <v-btn icon @click='sideMenu=!sideMenu' icon ><v-icon>menu</v-icon></v-btn>
      </v-toolbar-side-icon>
      <v-btn :loading='monthrequest.loading' icon flat small @click="update" >
        <v-icon >replay</v-icon>
      </v-btn>
      <v-divider vertical ></v-divider>
      <v-toolbar-title>{{ dateFormatted }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <space-and-location-picker @input='setFilters' />
      <search-field v-if='monthView' v-model='searchString' />
    </v-toolbar>

    <template v-if='monthView' >
      <v-flex>
        <v-card tile height="100%" >
          <request-status :request='monthrequest' :message200='false' />
          <v-calendar
            :value='startDate'
            :events="$store.getters.getEventRange"
            :type='monthViewType'
            :weekdays='weekdays'
            @click:date='zoomIn'
            @click:day='dayClicked' >

            <!-- all day view -->
            <template v-slot:day="{ date }" >
              <template v-for="event in getEvents(date)">
                <v-chip
                  v-if='event.id && ignoredStatuses.indexOf(event.status)'
                  :color='colleagues[event.practitioner].color'
                  :key='event.id'
                  @click.meta.stop='setSelectedAppointments(event)'
                  @click.exact.stop='setSelectedAppointment(event)'
                  class="v-chip--x-small ma-0" outline block style='width:100%;' >
                  <v-avatar
                    class='mr-1'
                    style='max-width:16px!important;max-height:16px!important;min-width:16px!important;min-height:16px!important;' >
                    <v-icon v-if="isSelected(event)" small >check</v-icon>
                    <img v-else :src='colleagues[event.practitioner].profile_picture' />
                  </v-avatar>
                  {{ event.title }}
                  <small style='position:absolute; right: 5px;'>{{ event.start }}</small>
                </v-chip>
              </template>
            </template>
            <!-- inline day view -->
            <!-- this appears not to exist in our version of vuetify -->
            <!-- <template v-slot:day-body="{ date, timeToY, minutesToPixels }">
              asd
              <template v-for="event in getEvents(date)" >
                <div
                  :key="event.id"
                  :style="{ top: timeToY(event.start) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                  class="my-event with-time" >
                  E: {{ event.title }}
                </div>
              </template>
            </template> -->

            <template v-slot:interval="{ date, hour }">
              <template
                v-for='(event) in getEventsByHour(date, hour)' >
                <interval-slot flat small
                  :color='colleagues[event.practitioner].color'
                  :events='getEvents(date)'
                  :event='event'
                  :key='`${event.id}-${date}-${hour}`' >
                </interval-slot>
              </template>
            </template>

          </v-calendar>
        </v-card>
      </v-flex>
    </template>
    <v-layout row wrap v-else >

      <v-flex :class='flexSize'
        v-for='practitioner in selectedPractitioners' :key='practitioner.id'>
        <practitioner-day-view with-title with-add with-fetch
          v-if='date'
          :practitioner='practitioner'
          :filter-spaces='filterSpaces'
          :filter-locations='filterLocations'
          :touch='dayViewTouch'
          :date='date' />
      </v-flex>

      <template v-if='visibleSharedCalendars && visibleSharedCalendars.length > 0' >
        <v-flex :class='flexSize'
          v-for='cal in visibleSharedCalendars' :key='cal.id'>
          <shared-calendar-day-view with-title with-add
            v-if='date'
            :calendar-id='cal.id'
            :title='cal.title'
            :date='date' />
        </v-flex>
      </template>

    </v-layout>
  </v-flex>

  <appointment-bottom-sheet
    v-model='bottomsheet'
    :appointment='selectedEvent'
    :readOnly='readOnly' >
  </appointment-bottom-sheet>

  <v-dialog v-model="addTeamMember" width='420' >
    <v-card>
      <v-card-title class='overline' >
        Coming soon
      </v-card-title>
      <v-card-text>
        This functionality is not yet available. To add a team member, please
        <a href='mailto:support@appointmentguru.co' >contact support</a>.
        Please note that there is an additional cost of R150/month for each additional team member
      </v-card-text>
      <v-card-actions >
        <v-btn @click='addTeamMember=false' text flat >Got it</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
</template>
<script>
import PractitionerDayView from './PractitionerDayView.vue'
import SharedCalendarDayView from './SharedCalendarDayView.vue'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import AppointmentBottomSheet from '@/components/appointment/actions/AppointmentBottomSheet.vue'
import SpaceAndLocationPicker from '@/components/pickers/SpaceAndLocationPicker'
import IntervalSlot from './IntervalSlot'
import SearchField from '@/components/ui/SearchField.vue'
import InviteBtn from '@/components/btns/InviteBtn.vue'
import Vue from 'vue'

import {SET_SETTING} from '@/store/constants'
import {DateTime} from 'luxon'
import {mapGetters} from 'vuex'

export default {
  name: 'TeamView',
  components: {
    PractitionerDayView,
    SharedCalendarDayView,
    PractitionerListItem,
    AppointmentBottomSheet,
    SpaceAndLocationPicker,
    IntervalSlot,
    SearchField,
    InviteBtn
  },
  props: {
    page: { type: String, required: false }
  },
  data () {
    return {
      idToDelete: 135455,
      activeTab: 1,
      date: null,
      monthView: false,
      hideWeekends: false,
      sideMenu: true,
      monthViewType: 'month',
      bottomsheet: false,
      readOnly: false,
      addTeamMember: false,
      ignoredStatuses: ['C'],
      selectedEvent: {},
      selectedPractitioners: {},
      searchString: '',
      filterSpaces: [],
      filterLocations: [],
      selectedAppointments: {},
      visibleSharedCalendarIds: [],
      monthrequest: {
        resource: 'ag.practitioner.appointments',
        status: 0
      },
      dayViewTouch: 0,
      colors: ['green', 'blue', 'yellow', 'teal', 'pink', 'red']
    }
  },
  computed: {
    ...mapGetters(['spaces', 'getSharedCalendars']),
    // ...mapGetters('application', ['getSharedCalendars']),
    colleagues () {
      return this.$store.getters.getColleagues
    },
    flexSize () {
      if (this.visibleSharedCalendarIds && this.selectedPractitionerIds) {
        let visibleCalendars = this.visibleSharedCalendarIds.length + this.selectedPractitionerIds.length
        let size = Math.floor(12 / visibleCalendars)
        return 'md' + size
      }
      return ''
    },
    pickerMode () {
      if (this.monthView) { return 'month' }
      return 'date'
    },
    requestStatus () {
      return this.monthrequest.status
    },
    monthevents () {
      return this.getObjectPath(this.monthrequest, 'result.results', [])
    },
    selectedAppointmentIds () {
      if (this.selectedAppointments) {
        return Object.keys(this.selectedAppointments)
      }
      return []
    },
    selectedPractitionerIds () {
      return Object.keys(this.selectedPractitioners)
    },
    startDate () {
      return DateTime.fromISO(this.date).toISODate()
      // return moment(this.date).format('YYYY-MM-DD')
    },
    dateFormatted () {
      if (this.date) {
        let dt = DateTime.fromISO(this.date)
        let f = null
        if (this.monthView) {
          f = dt.toFormat('MMM yyyy')
        } else {
          f = dt.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
        }
        return f
      }
    },
    monthToucher () {
      if (this.monthView) {
        return this.params.toString() + this.startDate + this.selectedPractitionerIds.toString()
      }
      return ''
    },
    weekdays () {
      if (this.monthView && this.hideWeekends) {
        return [1, 2, 3, 4, 5]
      }
      return [0, 1, 2, 3, 4, 5, 6]
    },
    // formattedMonthEvents () {
    //   let mappedEvents = {}
    //   this.monthevents.forEach((evt) => {
    //     let dt = evt.start_time.split('T')[0]
    //     if (!(dt in mappedEvents)) { mappedEvents[dt] = [] }
    //     mappedEvents[dt].push(evt)
    //   })
    //   return mappedEvents
    // },
    params () {
      if (this.date) {
        if (this.monthView) {
          let monthStart = DateTime.fromISO(this.date).startOf('month').toISODate()
          let monthEnd = DateTime.fromISO(this.date).endOf('month').toISODate()
          let params = new URLSearchParams()
          params.append('page_size', 1000)
          params.append('after_utc', monthStart)
          params.append('before_utc', monthEnd)
          if (this.selectedPractitionerIds) {
            this.selectedPractitionerIds.forEach((id) => {
              params.append('practitioners', id)
            })
          }
          return params
        }
      }
      return {}
    },
    visibleSharedCalendars () {
      return this.getSharedCalendars.filter((cal) => {
        return this.visibleSharedCalendarIds.indexOf(cal.id) > -1
      })
    }
  },
  mounted () {
    this.date = new Date().toISOString().split('T')[0]
    this.setView(this.page)
    this.getMonth()
  },
  methods: {
    update () {
      if (this.monthView) {
        this.getMonth()
      } else {
        this.dayViewTouch++
      }
    },
    getMonth () {
      this.monthrequest.params = this.params
      this.$request('get', this.monthrequest)
    },
    setFilters ({spaces, locations}) {
      this.filterSpaces = spaces
      this.filterLocations = locations
    },
    applyFilters (evts) {
      if (this.searchString) {
        evts = evts.filter((evt) => {
          let index = `${evt.title}`.toLowerCase()
          let search = this.searchString.toLowerCase()
          return index.indexOf(search) !== -1
        })
      }
      if (this.filterSpaces && this.filterSpaces.length > 0) {
        evts = evts.filter((evt) => {
          return this.filterSpaces.indexOf(evt.space) !== -1
        })
      }
      if (this.filterLocations && this.filterLocations.length > 0) {
        evts = evts.filter((evt) => {
          return this.filterLocations.indexOf(evt.address_id) !== -1
        })
      }
      return evts
    },
    getEvents (dt) {
      let evts = this.$store.getters.getCalendarsDay(this.selectedPractitionerIds, dt)
      return this.applyFilters(evts)
    },
    getEventsByHour (dt, hour) {
      let evts = this.getEvents(dt).filter((evt) => {
        return DateTime.fromISO(evt.start_time).hour === parseInt(hour)
      })
      return this.applyFilters(evts)
    },
    toggleSpace (space, filterSpaces) {
      let index = this.filterSpaces.indexOf(space.id)
      if (index === -1) {
        filterSpaces.push(space.id)
      } else {
        filterSpaces.splice(index, 1)
      }
    },
    isSelected (event) {
      if (event && event.id && this.globalSelectedAppointmentIds.indexOf(event.id) > -1) {
        return true
      }
      return false
    },
    setView (page) {
      if (page === 'month') {
        this.monthView = true
        this.activeTab = 0
      } else {
        this.monthView = false
        this.activeTab = 1
      }
    },
    setSelectedAppointments (appt) {
      this.$store.commit('toggleGloballySelectedAppointment', appt)
    },
    setSelectedAppointment (appt, evt) {
      this.readOnly = (appt.practitioner !== this.me.id)
      this.bottomsheet = false
      this.selectedEvent = appt
      window.setTimeout(() => { this.bottomsheet = true }, 100)
      // this.bottomsheet = true
    },
    setSelected (practitioner) {
      let practitionerId = practitioner.id
      if (practitionerId in this.selectedPractitioners) {
        Vue.delete(this.selectedPractitioners, practitionerId)
      } else {
        Vue.set(this.selectedPractitioners, practitionerId, practitioner)
      }
    },
    dayClicked (dt) {
      let vm = this
      // this.$store.commit(SET_SETTING, ['activePractitioner', practitionerId])
      window.setTimeout(() => { vm.$store.commit(SET_SETTING, ['startTime', dt.date]) }, 500)
      this.openGlobalDialog(true, 'QuickCreate')
    },
    newAppointment (practitioner) {
      let vm = this
      window.setTimeout(() => {
        vm.$store.commit(SET_SETTING, ['activePractitioner', practitioner])
      }, 500)
      this.openGlobalDialog(true, 'QuickCreate')
    },
    zoomIn (dateItem) {
      this.date = dateItem.date
      this.activeTab = 1
      this.monthView = false
    },
    asTime (dt) {
      return DateTime.fromISO(dt).asLocaleString(DateTime.TIME_24_SIMPLE)
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) {
        let events = this.getObjectPath(this.monthrequest, 'result.results', [])
        this.$store.commit('addAppointments', events)
      }
    },
    monthToucher () {
      if (this.monthView === true) {
        this.getMonth()
      }
    },
    monthView () {
      if (this.monthView !== true) {
        if (this.date.length < 10) { this.date += '-01' }
      }
      this.globalSelectedAppointments = []
    },
    page () {
      this.setView(this.page)
    },
    newAppointment (practitioner) {
      this.$store.commit(SET_SETTING, ['activePractitioner', practitioner])
      this.openGlobalDialog(true, 'QuickCreate')
    },
    getSharedCalendars () {
      this.visibleSharedCalendarIds = this.getSharedCalendars.filter((cal) => {
        if (cal.default_show) { return cal }
      }).map((cal) => { return cal.id })
    },
    colleagues: {
      immediate: true,
      handler () {
        this.selectedPractitioners = JSON.parse(JSON.stringify(this.colleagues))
        // this.selectedPractitionerIds.forEach((pId, index) => {
        //   let p = this.colleagues[pId]
        //   p.color = this.colors[index]
        //   Vue.set(this.colleagues, pId, p)
        // })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TeamView.vue?c3b1e048